import { render, staticRenderFns } from "./search-page.vue?vue&type=template&id=062c44f5&scoped=true&"
import script from "./search-page.vue?vue&type=script&lang=js&"
export * from "./search-page.vue?vue&type=script&lang=js&"
import style0 from "./search-page.vue?vue&type=style&index=0&id=062c44f5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062c44f5",
  null
  
)

export default component.exports